import Vue from 'vue';
import uuidv1 from 'uuid/v1';
import fb from '@/firebaseConfig';

const pdfViewerComponent = {
  namespaced: true,
  modules: {},
  state: () => ({
    startDrag: {},
    currentDrag: {},
    finalShape: {},
    currentResourceId: null,
    isScreenCapEnabled: false,
    captureCurrent: false,
    capturedImage: null,
    capturedText: { text: '', positions: [] },
    pagePositions: {}
  }),
  getters: {
    savedSelections: (state, getters, rootState) => {
      const selectedResource = rootState.resources.resources[state.currentResourceId];
      const noteBlocks = Object.values(selectedResource.noteBlocks);
      const savedSelections = noteBlocks
        .filter(noteBlock => {
          const widgetType = !!noteBlock && !!noteBlock.content && noteBlock.content.widgetType;
          return (
            (widgetType === 'textExcerpt' || widgetType === 'imageExcerpt') && !noteBlock.toDelete
          );
        })
        .map(noteBlock => {
          const toReturn = {
            ...noteBlock.content.widgetData,
            type: noteBlock.content.widgetType,
            excerptId: noteBlock.id
          };
          return toReturn;
        });
      return savedSelections;
    }
  },
  mutations: {
    setStartDrag(state, val) {
      state.startDrag = val;
    },
    setCurrentDrag(state, val) {
      state.currentDrag = val;
    },
    setFinalShape(state, val) {
      state.finalShape = val;
    },
    setCaptureCurrent(state, val) {
      state.captureCurrent = val;
    },
    setCapturedImage(state, val) {
      state.capturedImage = val;
    },
    toggleScreenCapState(state) {
      state.isScreenCapEnabled = !state.isScreenCapEnabled;
      if (!state.isScreenCapEnabled) {
        state.capturedImage = null;
        state.finalShape = {};
      }
    },
    setCapturedText(state, val) {
      console.log('set capturedText', val);
      state.capturedText = val;
      console.log(state.capturedText);
    },
    setPagePosition(state, { page, position }) {
      Vue.set(state.pagePositions, page, position);
    },
    setCurrentResourceId(state, { resourceId }) {
      console.log('setting Current Resource Id');
      state.currentResourceId = resourceId;
    }
  },
  actions: {
    async addImageToResource({ state, dispatch }) {
      const { url, pages, positions } = state.capturedImage;
      const imageId = uuidv1();

      ////// functions //////
      //upload Image
      const uploadImage = async function({ imageId, url }) {
        console.log('background upload image');
        const storageRef = fb.storage.ref();
        const fileRef = storageRef.child(imageId);

        //upload the image
        const result = await fileRef.putString(url, 'data_url');
        console.log('upload result', result);
        return result.status;
      };
      //save to resource
      const saveToResource = function({ positions, pages, imageId }) {
        const content = {
          widgetData: {
            imageRef: imageId,
            source: 'pdfViewer',
            title: 'my screenshot',
            verificationStatus: 'fail',
            verifyImageRef: null,
            verificationScore: null,
            pages: pages,
            positions: positions
          },
          widgetType: 'imageExcerpt'
        };
        dispatch(
          'resources/addNoteBlock',
          { resourceId: state.currentResourceId, content, type: 'widget' },
          { root: true }
        );
      };

      ////// Main //////
      const value = await uploadImage({ imageId, url });
      saveToResource({ positions, pages, imageId });

      then(value => {
        console.log('upload result', value);
      }).catch(e => {
        console.error('error uploading image', e);
      });
    },
    addSelectionToResourceExcerpt({ state, dispatch }, { text, positions, pageRange }) {
      //get the currently captured selection and the pages positions
      // get each page from el
      const pageArray = pageRange.map(p => {
        const rect = document.getElementById('textLayer-' + p).getBoundingClientRect();
        const { x, y, width, height, top, right, bottom, left } = rect;
        return { top, right, bottom, left, width, height, x, y, page: Number(p) };
      });
      console.log(pageArray);
      //const pageArray = Object.values(state.pagePositions);
      //created saved selection object which has the text and the positions on the page of the elements
      const savedSelection = {};
      savedSelection.pages = [];
      savedSelection.positions = [];
      savedSelection.text = text;
      if (pageRange.length > 1) {
        for (var i = pageRange[0]; i <= pageRange[1]; i++) {
          savedSelection.pages.push(i);
        }
      } else {
        savedSelection.pages.push(Number(pageRange[0]));
      }
      //loop through the positions and save which page each of the positions is located on
      positions.forEach(position => {
        const pageOfInterest = pageArray.find(page => {
          console.log(page, position);
          return page.top <= position.y && page.bottom >= position.y;
        });
        console.log(pageOfInterest);
        const thisPosition = {};
        //get the relative position of the element with regards to the page
        thisPosition.y = (position.y - pageOfInterest.top) / pageOfInterest.height;
        thisPosition.x = (position.x - pageOfInterest.left) / pageOfInterest.width;
        thisPosition.height = position.height / pageOfInterest.height;
        thisPosition.width = position.width / pageOfInterest.width;
        thisPosition.page = pageOfInterest.page;
        //add the selection and the page
        savedSelection.positions.push(thisPosition);
        // if (!savedSelection.pages.includes(pageOfInterest.page)) {
        //   savedSelection.pages.push(pageOfInterest.page);
        // }
      });

      const content = {
        excerpt: savedSelection.text,
        source: 'pdfViewer',
        pages: savedSelection.pages,
        positions: savedSelection.positions
      };

      this.$emit('saveExcerpt', content);
    }
  }
};

export default pdfViewerComponent;
